import { useEffect } from 'react';
import useThemeConfig from 'hooks/useThemeConfig';

// Default favicon path (fallback)
const DEFAULT_FAVICON = '/favicon.ico';

// ==============================|| FAVICON UPDATER ||============================== //

const FaviconUpdater = () => {
  const { themeConfig } = useThemeConfig();

  useEffect(() => {
    // Get favicon URL from theme config, fallback to default
    const faviconUrl = themeConfig?.icons?.fav_icon_path?.url || DEFAULT_FAVICON;
    
    // Find existing favicon link element
    let faviconLink: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
    
    // If no favicon link exists, create one
    if (!faviconLink) {
      faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      document.head.appendChild(faviconLink);
    }
    
    // Update the favicon href
    faviconLink.href = faviconUrl;
    
    // Also update shortcut icon if it exists
    const shortcutIcon: HTMLLinkElement | null = document.querySelector("link[rel~='shortcut icon']");
    if (shortcutIcon) {
      shortcutIcon.href = faviconUrl;
    }
    
    // Update apple-touch-icon if it exists
    const appleTouchIcon: HTMLLinkElement | null = document.querySelector("link[rel~='apple-touch-icon']");
    if (appleTouchIcon && themeConfig?.icons?.fav_icon_path?.url) {
      appleTouchIcon.href = faviconUrl;
    }
    
  }, [themeConfig]);

  // This component doesn't render anything
  return null;
};

export default FaviconUpdater;
